import React, { useCallback, useContext } from 'react'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import TasteOfGoldLearnMoreModal from './TasteOfGoldLearnMoreModal'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'

interface Props {
  /**
   * 'full' — used in the LERE-off heroSection.subtitle (title is already campaign-specific)
   * 'subtitle-only' — used in the LERE-on override (prefixed with campaign name since title stays as "Top picks for you")
   */
  variant: 'full' | 'subtitle-only'
}

function TasteOfGoldHeroSubtitleContent(props: Props) {
  const { variant } = props
  const showModal = useContext(ModalContext)

  const openLearnMore = useCallback(() => {
    showModal(<TasteOfGoldLearnMoreModal />)
  }, [showModal])

  const copy = variant === 'subtitle-only'
    ? 'Free airport transfer for international escapes. Limited time only.'
    : 'Free airport transfer for your next international escape. Limited time only.'

  return <>
    {variant === 'subtitle-only' && <>Experience {getLoyaltyProgramDisplayName()} {getLoyaltyTierDisplayName('gold')} — </>}
    {copy}{' '}
    <TextLink wrap="no-wrap" weight="regular" onClick={openLearnMore}>Learn more</TextLink>
  </>
}

export default TasteOfGoldHeroSubtitleContent
